import { Button } from '@/components/UI/Button'
import { Dialog } from '@/components/UI/Dialog'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  onClose: () => void
  /** storybookで確認する際に、スクロール可にするためのフラグ。raundで利用する場合にはtrue */
  scrollLock?: boolean
  audioGuides?: { caption: string | null; audio: string | null }[] | null
}

/**
 * `Raund-Replace / Screen UI / SPOT-VOICE-GUIDE`のダイアログコンポーネント
 */
export const DialogSpotsAudioGuide = memo(({ onClose, scrollLock = false, audioGuides }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog
      selectorState={true}
      showCloseButton={false}
      lockScroll={scrollLock}
      closeAction={onClose}
      title={t('spot_detail.audio_guide.title', '音声ガイド')}
    >
      {audioGuides && audioGuides.length > 0 && (
        <ul className="mt-[25px]">
          {audioGuides.map((guide, i) => (
            <li key={`${guide.caption}-${i}`} className="mb-[20px] last:mb-0">
              <p className="mb-[8px] ml-[8px] text-[14px] font-bold">{guide.caption ?? ''}</p>
              {/* biome-ignore lint/a11y/useMediaCaption: スポットの音声ガイドにキャプショントラックは供給されない */}
              {guide.audio && <audio className="w-full" controls src={guide.audio} controlsList="nodownload" />}
            </li>
          ))}
        </ul>
      )}

      <div className="mt-[20px] flex justify-center">
        <Button label={t('common.close', '閉じる')} variant="primary" size="md" onClick={onClose} fullWidth />
      </div>
    </Dialog>
  )
})
